import React from "react";
import { toast } from "react-toastify";
import { messageConfig } from "./constants";
import { Box, Typography } from "@mui/material";
import { IUseNotificationToast } from "./types";
import { styles } from "./useNotificationToast.styled";

const useNotificationToast = ({ type, message }: IUseNotificationToast) => {
  toast[type](() => {
    return (
      <Box>
        <Box>
          <Box sx={styles.titleWrapper}>
            {messageConfig[type].icon}
            <Typography
              sx={[styles.title, styles.titleColor(messageConfig[type].color)]}
            >
              {messageConfig[type].title}
            </Typography>
          </Box>
          <Typography sx={styles.message}>
            {message || messageConfig[type].message}
          </Typography>
        </Box>
      </Box>
    );
  });
};

export default useNotificationToast;
